import React from 'react';
import { useStaticQuery, graphql, Link } from "gatsby"
import Layout from "../components/Layout"
import Insight from "../components/NewsInsight/Insight";
import ServiceCard from "../components/ServiceCard/ServiceCard";
import { breadcrumbs } from "../common/utils/breadcrumbs";
import _ from "lodash";

const NewsTemplate = (props) => {

  var GQLPage = props.GQLPage;
  var GQLModules = props.GQLModules;
  const breadcrumbsList = breadcrumbs(GQLPage.menu);

  const today = new Date().toISOString().split("T")[0] // "YYYY-MM-DD"
  
  const data = useStaticQuery(graphql`
      query NewsQuery{
        glstrapi {
          blogs(sort:"createdAt:desc",where:{publish:true, categories_nin:["Investments"]}) {
            id
            title
            categories
            description
            embed_video_url
            post_on
            tile_image {
              url
              alternativeText
            }
            tags
            slug
            publish
            imagetransforms
            ggfx_results {
              id
              transforms
              src_cftle
              src_url
            }
            createdAt
            updatedAt
          }
        }
      }`)

  var news = data.glstrapi?.blogs; 
  const categories = _.concat(['all_categories'], _.uniq(_.map(news, 'categories')));

  news = news.filter(post => {
    //console.log("news ==> filter", new Date(post.post_on), today, new Date())
    return new Date(post.post_on) <= new Date()
  })

  const getEffectiveDate = (blog) => {
    const created = new Date(blog.createdAt);
    const custom = blog.post_on ? new Date(blog.post_on) : null;

    return custom && custom > created ? custom : created;
  };

  const sortedBlogs = news.sort((a, b) => getEffectiveDate(b) - getEffectiveDate(a));

  news = sortedBlogs;


  return (
    <div className="search-header property-header news-page">
      <Layout seo_meta={GQLPage.seo_meta} menu_slug={GQLPage?.menu?.slug} popular_search={GQLPage?.menu?.popular_search} GQLPage={GQLPage}>
        <Insight title={GQLPage?.title} content={GQLPage?.content} breadcrumbs={breadcrumbsList} />

        <ServiceCard categories={categories} news={news} GQLModules={GQLModules} />
      </Layout>
    </div>
  )

}

export default NewsTemplate